
const TENANT_STYLES_FALLBACK = {
  background: 'tobeset',
  favicon: null,
  logos: ['', ''],
  colors: {
    base_black: 'black',
    base_blue: 'blue',
    base_green: '#27ae60',
    base_grey: null,
    base_grey_light: '#8c8c8c',
    base_grey_medium: null,
    base_indigo: '#8e44ad',
    base_orange: '#E69D32',
    base_red: '#e60050',
    base_violet: '#6400aa',
    base_white: 'white',
    base_yellow: '#f1c40f',
    button_danger: 'tobeset',
    button_default: null,
    button_default_hovered: null,
    button_default_text: null,
    button_info: 'tobeset',
    button_primary: '#333333',
    button_primary_hovered: '#404040',
    button_primary_text: null,
    button_success: 'tobeset',
    button_warning: 'tobeset',
    danger: '#0000FF',
    default: '#ffffff',
    footer_color: 'rgb(51, 51, 51)',
    footer_hover_color: 'tobeset',
    footer_text_color: 'tobeset',
    footer_text_hover_color: 'tobeset',
    form_color_dark: '#666666',
    form_color_light: '#ddd',
    info: '#0000FF',
    navbar_color: 'rgb(51, 51, 51)',
    navbar_hover_color: 'tobeset',
    navbar_text_color: 'tobeset',
    navbar_text_hover_color: 'tobeset',
    primary_border_color: 'tobeset',
    primary_color: '#333333',
    primary_color_light: 'tobeset',
    primary_color_transparent: 'rgba(102, 102, 102, .6)',
    primary_dark_text: '#0000FF',
    primary_light_text: '#0000FF',
    secondary_border_color: 'tobeset',
    secondary_color: '#666666',
    secondary_color_light: 'tobeset',
    secondary_color_transparent: 'tobeset',
    secondary_dark_text: '#0000FF',
    secondary_light_text: '#0000FF',
    sidebar_color: '#d4d4d4',
    sidebar_hover_color: '#ddd',
    sidebar_text_color: '#666666',
    sidebar_text_hover_color: 'tobeset',
    success: '#0000FF',
    tertiary_color: '#333333',
    tertiary_color_light: 'tobeset',
    tertiary_color_transparent: 'tobeset',
    warning: '#0000FF'
  }
}

export default {
  TENANT_STYLES_FALLBACK: TENANT_STYLES_FALLBACK
}
